import { render, staticRenderFns } from "./HousingSummary.vue?vue&type=template&id=57a642de&scoped=true"
import script from "./HousingSummary.vue?vue&type=script&lang=js"
export * from "./HousingSummary.vue?vue&type=script&lang=js"
import style0 from "./HousingSummary.vue?vue&type=style&index=0&id=57a642de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a642de",
  null
  
)

export default component.exports